import { Component } from '@angular/core'

@Component({
  selector: 'se-po-address-docs',
  templateUrl: './address-docs.component.html',
  styleUrls: ['./address-docs.component.scss'],
  standalone: false,
})
export class AddressDocsComponent {
  public models: string[]
  public headers: string[] = [
    'Property',
    'Type',
    'Description',
  ]
  public addressValueFields: any = [
    {
      Property: 'city?',
      Type: 'string',
      Description: 'City',
    },
    {
      Property: 'country?',
      Type: 'string',
      Description: 'Country abbreviation (US, CA)',
    },
    {
      Property: 'street_1?',
      Type: 'string',
      Description: 'Street',
    },
    {
      Property: 'state_or_province?',
      Type: 'string',
      Description: 'State or province abbreviation (MN, BC, etc)',
    },
    {
      Property: 'zip?',
      Type: 'string',
      Description: 'Zip code',
    }
  ]
}
